module.exports = __webpack_public_path__ + "static/img/iphone_room7.9966502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room7.png
// module id = T6Tn
// module chunks = 0